import { selectorActiveNotifications } from "./selectorActiveNotifications";

import {
  NotificationHandleType,
  WSNotificationResponse
} from "../components/Notifications";
import { InsuranceCoverageMonitoringContractorContext } from "../components/Notifications/templates/InsuranceCoverageMonitoringContractor";

export const selectorInsuranceCoverageMonitoringContractorNotifications = (
  responses: WSNotificationResponse[]
) => {
  return selectorActiveNotifications(responses).filter(response => {
    return (
      response.handle ===
      NotificationHandleType.InsuranceCoverageMonitoringContractor
    );
  }) as Array<
    WSNotificationResponse<InsuranceCoverageMonitoringContractorContext>
  >;
};
